module.exports = __webpack_public_path__ + "img/multiplier_64.252a26f1.png";